class ServiceWorkerRegistration {
  constructor() {
    this.registration = null;
    this.updateFound = false;
  }

  async register() {
    if ('serviceWorker' in navigator) {
      try {
        console.log('Enregistrement du service worker...');
        
        this.registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/'
        });

        console.log('Service Worker enregistré avec succès:', this.registration);

        // Écouter les mises à jour
        this.registration.addEventListener('updatefound', () => {
          console.log('Nouvelle version du service worker détectée');
          this.updateFound = true;
          
          const newWorker = this.registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('Nouveau service worker installé, prêt pour activation');
              this.notifyUpdateAvailable();
            }
          });
        });

        // Écouter les changements de contrôleur
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('Nouveau service worker activé');
          this.updateFound = false;
          
          // Recharger la page pour utiliser la nouvelle version
          window.location.reload();
        });

        return this.registration;
      } catch (error) {
        console.error('Erreur lors de l\'enregistrement du service worker:', error);
        throw error;
      }
    } else {
      console.warn('Service Worker non supporté par ce navigateur');
      return null;
    }
  }

  // Notifier qu'une mise à jour est disponible
  notifyUpdateAvailable() {
    const event = new CustomEvent('swUpdateAvailable', {
      detail: {
        registration: this.registration
      }
    });
    window.dispatchEvent(event);
  }

  // Forcer l'activation du nouveau service worker
  async skipWaiting() {
    if (this.registration && this.registration.waiting) {
      console.log('Activation du nouveau service worker...');
      
      // Envoyer un message au service worker pour activer la nouvelle version
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  }

  // Obtenir l'état du service worker
  getStatus() {
    if (!this.registration) {
      return { registered: false };
    }

    return {
      registered: true,
      updateFound: this.updateFound,
      installing: !!this.registration.installing,
      waiting: !!this.registration.waiting,
      active: !!this.registration.active,
      scope: this.registration.scope
    };
  }

  // Vérifier si une mise à jour est disponible
  async checkForUpdates() {
    if (this.registration) {
      try {
        await this.registration.update();
        console.log('Vérification de mise à jour du service worker effectuée');
      } catch (error) {
        console.error('Erreur lors de la vérification de mise à jour:', error);
      }
    }
  }

  // Nettoyer les ressources
  cleanup() {
    if (this.registration) {
      this.registration = null;
    }
    this.updateFound = false;
  }
}

// Instance singleton
export const swRegistration = new ServiceWorkerRegistration(); 